import { StructureSelctionFilter, StructureSelection, StructureSelectionContext, StructureSelectionDialogScope } from './../../../../common/structure-selection/structure-selection.model';
import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog }from "@angular/material/legacy-dialog";
import { Observable } from "rxjs";
import { ForwardToStationStructureSelectionDialogComponent } from "../component/forward-to-station.component";


@Injectable({
    providedIn: 'root'
})
export class ForwardToStationService {

    constructor(private dialog: MatDialog) { }

    selectStationSetOrStation(): Observable<any> {
        return this.showDialog(new StructureSelectionContext(
            StructureSelectionDialogScope.STATION_OR_STATION_SET, new StructureSelection(), StructureSelctionFilter.ANY));
    }

    private showDialog(selectionContext: StructureSelectionContext): Observable<any> {
        return this.dialog.open(ForwardToStationStructureSelectionDialogComponent, {
            height: '95%',
            width: '95%',
            maxHeight: '960px',
            maxWidth: '1280px',
            data: selectionContext
        }).afterClosed();
    }
}
